/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import Grid from '@mui/material/Unstable_Grid2';
import moment from 'moment';
import { toast } from 'react-toastify';
// API
import { getManagerFilter, getRepFilter } from '../../../api/filterOptionsApi';
// Context
import useFieldEngagementContext from '../context/useFieldEngagementContext';
// Helpers
import {
  filterMultiValue,
  filterManagerOptions,
  filterRepOptions,
} from '../../../helpers/filterFunctions';

export default function Filter() {
  const { filterForm, setFilterForm, handleGenerateFilter, handleClearFilter } =
    useContext(useFieldEngagementContext);

  const [managerOptions, setManagerOptions] = useState([]);
  const [repOptions, setRepOptions] = useState([]);

  const loadManagerDropdown = async () => {
    const request = {
      department: ['CREDIT & COLLECTION'],
      rep_id: filterMultiValue(filterForm?.rep_id),
      month: [Number(moment(filterForm.month_year).format('MM'))],
      year: [Number(moment(filterForm.month_year).format('YYYY'))],
    };
    const reponse = await getManagerFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterManagerOptions(data);
      setManagerOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadRepDropdown = async () => {
    const request = {
      department: ['CREDIT & COLLECTION'],
      manager_id: filterMultiValue(filterForm?.manager_id),
      month: [Number(moment(filterForm.month_year).format('MM'))],
      year: [Number(moment(filterForm.month_year).format('YYYY'))],
    };
    const reponse = await getRepFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterRepOptions(data);
      setRepOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const handleChangeFrom = (value) => {
    setFilterForm({ ...filterForm, month_year: moment(value).format('YYYY-MM') });
  };
  useEffect(() => {
    loadManagerDropdown();
    loadRepDropdown();
  }, [filterForm]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid md={2}>
          <Autocomplete
            id='manager_id'
            multiple
            fullWidth
            filterOptions={(x) => x}
            options={managerOptions}
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={filterForm.manager_id ?? []}
            noOptionsText='No Manager'
            onChange={(event, newValue) => {
              let updatedNewValue = newValue;

              if (newValue.length === 0) {
                // if remove all month option set default to all
                updatedNewValue = [managerOptions[0]];
              } else if (newValue[newValue.length - 1].value === null) {
                // if last selected in ALL, remove all other options and retain ALL
                updatedNewValue = [managerOptions[0]];
              } else if (newValue.length !== 1) {
                // if selected other months, remove ALL in selected options
                updatedNewValue = newValue.filter(
                  (option) => option.value !== managerOptions[0].value,
                );
              }

              setFilterForm({
                ...filterForm,
                manager_id: updatedNewValue,
              });
            }}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='Manager' fullWidth />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            id='rep_id'
            multiple
            fullWidth
            filterOptions={(x) => x}
            options={repOptions}
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={filterForm.rep_id ?? []}
            noOptionsText='No Account Specialist'
            onChange={(event, newValue) => {
              let updatedNewValue = newValue;

              if (newValue.length === 0) {
                // if remove all month option set default to all
                updatedNewValue = [repOptions[0]];
              } else if (newValue[newValue.length - 1].value === null) {
                // if last selected in ALL, remove all other options and retain ALL
                updatedNewValue = [repOptions[0]];
              } else if (newValue.length !== 1) {
                // if selected other months, remove ALL in selected options
                updatedNewValue = newValue.filter((option) => option.value !== repOptions[0].value);
              }

              setFilterForm({
                ...filterForm,
                rep_id: updatedNewValue,
              });
            }}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='Account Specialist' fullWidth />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>
        <Grid md={2}>
          <DatePicker
            label='month_year'
            views={['month', 'year']}
            value={filterForm?.month_year}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => (
              <TextField {...params} label='Month Year' size='small' fullWidth />
            )}
            onChange={(value) => handleChangeFrom(value)}
          />
        </Grid>
        <Grid md={2}>
          <Button variant='contained' color='success' onClick={handleGenerateFilter}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => handleClearFilter()}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
